/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the project links
 *
 * @param  {Object} state
 * @param  {Array} links
 * @return {Void}
 */
const GET_PROJECT_LINKS_SUCCESS = (state, links) => {
    state.data = links
}

/**
 * Handle a failed request for project links
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_PROJECT_LINKS_FAILURE = (state) => {
    state.data = []
}

/**
 * Update a link item's status
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_LINK_STATUS = (state, payload) => {
    state.data[payload.parentIndex].links[payload.childIndex].active = payload.status
}

/**
 * Update the search value
 *
 * @param  {Object} state
 * @param  {String} value
 * @return {Void}
 */
const UPDATE_SEARCH_VALUE = (state, value) => {
    state.searchTerm = value
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Remove a link from the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const LINK_REMOVED_SUCCESS = (state, id) => {
    let parentIdx = null
    let idx = null
    state.data.forEach((obj, parentIndex) => {
        let found = obj.links.findIndex(link => link.id === id)
        if (found > -1) {
            idx = found
            parentIdx = parentIndex
        }
    })

    if (parentIdx !== null && idx !== null) {
        state.data[parentIdx].links.splice(idx, 1)
        if (state.data[parentIdx].links.length === 0) {
            state.data.splice(parentIdx, 1)
        }
    }
}

/**
 * Handle failed link removal
 *
 * @param  {Object} state
 * @return {Void}
 */
const LINK_REMOVED_FAILURE = (state, err) => {
    console.log(err)
}

export default {
    RESET_STATE,
    UPDATE_LINK_STATUS,
    UPDATE_SEARCH_VALUE,
    LINK_REMOVED_SUCCESS,
    LINK_REMOVED_FAILURE,
    GET_PROJECT_LINKS_SUCCESS,
    GET_PROJECT_LINKS_FAILURE
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/links/mutations.js